<template>
  <div class="col-lg-8 offset-lg-2">
    <card class="card-nav-tabs text-center mb-5" header-classes="card-header-primary">
      <div slot="header">
        <h4 class="mt-1">{{ $t("message.Share your feedback") }}</h4>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-6 col-md-3 text-left pr-0" style="line-height: 35px">
              {{ $t("message.Audio/Video quality") }}
            </div>
            <div class="col-6 pl-0">
              <star-rating v-model="feedback.content.rating.audioVideo" :item-size="starSize"></star-rating>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-6 col-md-3 text-left pr-0" style="line-height: 35px">
              {{ $t("message.Consultation experience") }}
            </div>
            <div class="col-6 pl-0">
              <star-rating v-model="feedback.content.rating.consultationExperience" :item-size="starSize"></star-rating>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-6 col-md-3 text-left pr-0" style="line-height: 35px">
              {{ $t("message.Usability of app") }}
            </div>
            <div class="col-6 pl-0">
              <star-rating v-model="feedback.content.rating.usability" :item-size="starSize"></star-rating>
            </div>
          </div>
        </div>
        <div class="col-12">
          <textarea class="form-control" :placeholder="$t('message.Describe your experience here')" rows="3" v-model="feedback.content.comment"></textarea>
        </div>
      </div>
      <div slot="footer" class="text-muted">
        <div class="row">
          <div class="col-6">
            <n-button type="primary" simple round @click.native="goToHome()" id="submit-btn">
              <h6 class="m-0">{{ $t("message.Go to home") }}</h6>
            </n-button>
          </div>
          <div class="col-6">
            <n-button type="primary" round @click.native="submitFeedback()" :disabled="feedbackSubmitDisabled" id="submit-btn">
              <h6 class="m-0">{{ $t("message.Submit") }}</h6>
            </n-button>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: "feedback",

  data() {
    return {
      feedback: {
        type: "appointment",
        content: {
          rating: {
            audioVideo: 0,
            consultationExperience: 0,
            usability: 0,
          },
          comment: "",
        },
      },
      IS_PATIENT: false,
      IS_NURSE: false,
      starSize: 25,
    };
  },

  mounted() {
    this.$root.onBackButton = () => {
      this.goToHome();
    };
  },

  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
    feedbackSubmitDisabled() {
      return (
        this.feedback.content.comment == "" &&
        this.feedback.content.rating.audioVideo == 0 &&
        this.feedback.content.rating.consultationExperience == 0 &&
        this.feedback.content.rating.usability == 0
      );
    },
  },
  mounted() {
    this.IS_PATIENT = this.user.roles.includes("patient");
    this.IS_NURSE = this.user.roles.includes("nurse");
  },
  methods: {
    async submitFeedback() {
      //If the user is nurse, patient will give the feedback
      if (this.IS_NURSE || this.IS_PATIENT) {
        this.feedback.from =
          this.appointment.patient.firstName +
          " " +
          this.appointment.patient.lastName;
      } else {
        this.feedback.from = this.user.firstName + " " + this.user.lastName;
      }
      try {
        await this.$store.dispatch("updateFeedback", {
          appointmentId: this.appointment._id,
          feedback: this.feedback,
          IS_PATIENT_FEEDBACK: this.IS_NURSE || this.IS_PATIENT,
        });

        swal
          .fire({
            type: "success",
            title: this.$t("message.Thank you for your feedback!"),
            text: this.$t("message.Feedback submitted"),
            timer: 3000,
          })
          .then(() => {
            if (this.user.roles.includes("nurse")) {
              this.$router.push("/nursehome");
            } else if (this.user.roles.includes("patient")) {
              this.$router.push("/patienthome");
            } else {
              this.$router.push("/home");
            }
          });
      } catch (e) {
        console.log(e);
      }
    },
    goToHome() {
      //Common
      if (this.user.roles.includes("nurse")) {
        this.$router.push("/nursehome");
      } else if (this.user.roles.includes("patient")) {
        this.$router.push("/patienthome");
      } else {
        this.$router.push("/home");
      }
    },
  },
};
</script>

<style scoped>
/deep/ textarea.form-control {
  border: 1px solid #e3e3e3;
  border-radius: 12px;
}
</style>
